const STRAVA_STATE_KEY = 'strava_oauth_state';

export function generateStravaState(): string {
    const state = crypto.randomUUID();
    sessionStorage.setItem(STRAVA_STATE_KEY, state);
    return state;
}

export function verifyStravaState(state: string | null): boolean {
    if (!state) return false;
    const stored = sessionStorage.getItem(STRAVA_STATE_KEY);
    sessionStorage.removeItem(STRAVA_STATE_KEY);
    return stored === state;
}
